import { useState } from "react";
import { PhysShell, Field, ResultCard, Stat, primaryBtn } from "./PhysShell.jsx";
import { waves, round } from "./physcore.js";

export default function Waves() {
  const [v, setV] = useState("343");
  const [f, setF] = useState("440");
  const [lambda, setLambda] = useState("");
  const [res, setRes] = useState(null);

  const go = () => {
    const p = (x) => (x.trim() === "" ? null : parseFloat(x));
    setRes(waves({ v: p(v), f: p(f), lambda: p(lambda) }));
  };

  return (
    <PhysShell title="Wave Calculator">
      <p style={{ fontSize: 13, color: "#5B5E7A", marginTop: 0 }}>
        v = f λ. Fill any two, leave the unknown blank. Period T = 1/f also shown.
      </p>
      <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
        {[["Sound (air)", "343"], ["Light / EM", "299792458"]].map(([lbl, val]) => (
          <button
            key={lbl}
            onClick={() => { setV(val); }}
            style={{ background: "#1C1E2E", color: "#9A9DBE", border: "none", borderRadius: 8, padding: "7px 12px", fontSize: 12.5, cursor: "pointer" }}
          >
            v = {lbl}
          </button>
        ))}
      </div>
      <Field label="Wave speed v" suffix="m/s" value={v} onChange={(e) => setV(e.target.value)} placeholder="—" />
      <Field label="Frequency f" suffix="Hz" value={f} onChange={(e) => setF(e.target.value)} placeholder="—" />
      <Field label="Wavelength λ" suffix="m" value={lambda} onChange={(e) => setLambda(e.target.value)} placeholder="—" />
      <button onClick={go} style={primaryBtn}>Solve</button>
      {res && !res.ok && <ResultCard><span style={{ color: "#F8716A" }}>{res.error}</span></ResultCard>}
      {res && res.ok && (
        <ResultCard>
          <Stat label="Wave speed v" value={round(res.result.v, 4)} unit="m/s" />
          <Stat label="Frequency f" value={round(res.result.f, 4)} unit="Hz" />
          <Stat label="Wavelength λ" value={round(res.result.lambda, 6)} unit="m" />
          <Stat label="Period T" value={round(res.result.T, 6)} unit="s" />
          {res.steps && (
            <div style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid #1C1E2E" }}>
              <div style={{ fontSize: 12.5, color: "#9A9DBE", marginBottom: 8 }}>{res.formula}</div>
              {res.steps.map((s, i) => (
                <div key={i} style={{ fontSize: 12.5, color: "#C8CADF", fontFamily: "ui-monospace, monospace", padding: "3px 0" }}>{s}</div>
              ))}
            </div>
          )}
        </ResultCard>
      )}
    </PhysShell>
  );
}
